export default __webpack_public_path__ + "static/media/plane.d211f1c5.svg";